import { useQuery } from "react-query";
import { LoadingDots } from "web-ui";

import { type Release, getAllVersionsPerRelease } from "api/dashboardBackend";
import strings from "components/common/Common.strings.json";
import UsefulLinksAndroid from "components/release/useful-links/UsefulLinksAndroid";
import UsefulLinksChina from "components/release/useful-links/UsefulLinksChina";
import UsefulLinksIOS from "components/release/useful-links/UsefulLinksIOS";
import { PlatformId } from "util/platform";
import { buildVersionString } from "util/version";

interface Props {
  platformId: PlatformId;
  release: Release;
}

const UsefulLinks = ({ platformId, release }: Props) => {
  const versionString = buildVersionString(release);

  const {
    data: data,
    isError: isError,
    isLoading: isLoading,
  } = useQuery({
    queryFn: () => getAllVersionsPerRelease(platformId, versionString),
    queryKey: [platformId, versionString, "useful-links"],
  });

  if (isError) {
    return <div>{strings.data_fetch_error}</div>;
  }

  if (!isError && !isLoading && !data) {
    return <div>{strings.no_data}</div>;
  }

  if (isLoading) {
    return <LoadingDots manualPositioning={true} type="screen-white" />;
  }

  switch (platformId.toLowerCase()) {
    case PlatformId.Android:
      return (
        <UsefulLinksAndroid
          appBuildUrls={release.appBuildUrls}
          versions={data}
        />
      );
    case PlatformId.China:
      return (
        <UsefulLinksChina appBuildUrls={release.appBuildUrls} versions={data} />
      );
    case PlatformId.IOS:
      return (
        <UsefulLinksIOS appBuildUrls={release.appBuildUrls} versions={data} />
      );
    default:
      return null;
  }
};

export default UsefulLinks;
